// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "arec-h-icontext{width:100%}", "",{"version":3,"sources":["webpack://ClientApp/app/components/arec-icontext/arec-h-icontext.scss"],"names":[],"mappings":"AACA,gBACE,UACF","sourcesContent":["/*$color_arec_darkblue: #004C8A;*/\narec-h-icontext {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
